import { useConfirm } from "melco-shared-logic";
import { Space, Radio, Button, SaveIcon } from "melco-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useSwitchPaymentMode } from "../../hooks/users/useSwitchPaymentMode";
import { isEmpty } from "lodash-es";
import { useNavigate } from "react-router-dom";

type SwitchPaymentModeOptionsProps = {
    onCloseDrawer: (closeDrawer: boolean) => void;
    user: any;
};

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const SwitchPaymentModeOptions: React.FC<SwitchPaymentModeOptionsProps> = ({
    onCloseDrawer,
    user,
}) => {
    const { t } = useTranslation();
    const [paymentMode, setPaymentMode] = useState(user?.payment_mode ?? undefined);
    const paymentModeSwitcher = useSwitchPaymentMode(user?.id ?? undefined, paymentMode ?? undefined);
    const navigate = useNavigate();


    const confirmSwitchPaymentMode = useConfirm(
        async () => {
            //TODO: Handle case if user.id doesnt exist
            if (user.id) {
                const successfullySwitch = await paymentModeSwitcher();

                // redirect to list view in case the user was switched successfully
                if (!isEmpty(successfullySwitch)) {
                    navigate(`/users`);
                }
                else {
                    onCloseDrawer(false);
                }
            }
        },
        {
            translationPrefix: "users.actions.switch_payment_mode",
            translationOptions: {
                count: 1,
            },
        }
    );

    return (<>
        <Right direction="vertical" size="small">
            <Button
                icon={<SaveIcon />}
                type="primary"
                // disabled={isSubmitting}
                // loading={isSubmitting}
                onClick={() => {
                    confirmSwitchPaymentMode();
                }}
                style={{ marginBottom: "15px" }}
            >
                {t("users.actions.switch_payment_mode.save_button")}
            </Button>
        </Right>
        <div>
            <Radio.Group
                value={paymentMode ? paymentMode : null}
                onChange={(e) => {
                    // Ensure only a single value is stored/selected
                    setPaymentMode(e.target.value);
                }}>
                <Space direction="vertical">
                    <Radio value={1}>{t("users.actions.switch_payment_mode.options.automatic")}</Radio>
                    <Radio value={2}>{t("users.actions.switch_payment_mode.options.manual")}</Radio>
                    <Radio value={3}>{t("users.actions.switch_payment_mode.options.internal")}</Radio>
                </Space>
            </Radio.Group>
        </div></>
    );
};
